import { createSelector } from 'reselect';
import { appAIAlertFeatureFlagSelector } from '@store/common/selectors';
import { useSelector } from 'react-redux';
import { allDimensionsListSelector } from '@src/store/common/dimensionList/selectors';

export const appAIAlertEnabledSelector = createSelector(
  (state) => appAIAlertFeatureFlagSelector(state),
  (appAIAlert) => {
    return appAIAlert;
  },
);

export function useExistentDimension<T = string[] | object[]>(dimensions: T, key?: string): T {
  const allDimensionList = useSelector<any, Array<{ field: string }>>(allDimensionsListSelector);
  const fields = allDimensionList.map((it) => it.field);
  return (dimensions ?? []).filter((it) => {
    const field = key ? it[key] : it;
    return fields.includes(field);
  });
}
